import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import { CSSTransition } from 'react-transition-group'
import classnames from 'classnames'

import DropdownContainer from '../../common/dropdown'
import ListContainer from '../../common/list'
import { scrollTop, goToPage } from '../../../util'
import { animationSettings } from '../../../config'
import { trackPageView } from '../../../util/analytics'

class DocsNavContainer extends Component {
  constructor () {
    super()
    this.state = {
      narrowViewport: true
    }

    this.handleResize = this.handleResize.bind(this)
    this.onItemClick = this.onItemClick.bind(this)
  }

  componentDidMount() {
    this.handleResize()
    window.addEventListener('resize', debounce(this.handleResize), 200)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', debounce(this.handleResize), 200)
  }

  handleResize() {
    this.setState({ narrowViewport: window.innerWidth < 768 })
  }

  handleSelectionChange(selectedItemData) {
    if (!selectedItemData) {
      return;
    }
    const { index, selected, items } = selectedItemData;
    let hier2;
    for (let i = index - 1; i >= 0; i--) {
      const item = items[i];
      if (item.folder) {
        hier2 = item.id
        break;
      }
    }
    trackPageView({
      name: selected.id,
      hier1: 'sla',
      hier2,
    })
  }

  onItemClick (slug) {
    const { sectionHash='sla' } = this.props
    scrollTop()
    goToPage(`/${sectionHash}/${slug}`)
  }

  render () {
    const { navItems, sectionFolder, slug } = this.props
    const { narrowViewport } = this.state
    const isNavigable = true
    const _timeout = animationSettings.timeout
    const navClassNames = classnames('nav')
    let DocumentationTitle = ''

    if( sectionFolder && sectionFolder.length ) {
      let [firstLetter, ...restText] = Array.from(sectionFolder)
      DocumentationTitle = firstLetter.toUpperCase() + restText.join('')
    }

    return (
      <nav className={navClassNames}>

        {/* DropDown */}
        <CSSTransition
          in={isNavigable  && narrowViewport}
          timeout={_timeout}
          classNames='wb-e-dropd-1'
          unmountOnExit
        >
          <DropdownContainer
            items={navItems}
            selectedItem={slug}
            onSelectChange={this.onItemClick}
            title={`${DocumentationTitle} Documentation`}
            unselectedText='Select a page..'
            disabled=''
          />
        </CSSTransition>

        {/* List */}
        <CSSTransition
          in={isNavigable && !narrowViewport}
          timeout={_timeout}
          classNames='wb-e-linklist-1'
          unmountOnExit
        >
          <ListContainer
            items={navItems}
            selectedItem={slug}
            onItemClick={this.onItemClick}
            onSelectionChange={this.handleSelectionChange}
          />
        </CSSTransition>
      </nav>
    )
  }
}

DocsNavContainer.propTypes = {
  navItems: PropTypes.array, sectionFolder: PropTypes.string, slug: PropTypes.string
}

const mapStateToProps = function (state) {
  const { isFetching, apiAccess, filterTerm, selectedTenant } = state.tenants

  return {
    isFetching,
    apiAccess,
    filterTerm,
    selectedTenant
  }
}

export default connect(mapStateToProps)(DocsNavContainer)

